import { render } from "./Contacto.vue?vue&type=template&id=31a1122d&scoped=true"
const script = {}

import "./Contacto.vue?vue&type=style&index=0&id=31a1122d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a1122d"]])

export default __exports__